import { useMemo } from "react";
import { useFetchGet } from "hooks/fetch/useFetchGet";

interface PowerBiEmbedConfig {
  loading: boolean;
  error: boolean;
  embedConfig?: {
    embedTokenId: string;
    embedToken: string;
    tokenExpiry: string;
    reportConfigs: ReportConfig[];
    defaultReportId: string;
  };
}

export interface ReportConfig {
  reportId: string;
  reportName: string;
  embedUrl: string;
  datasetId: string;
}

export function useGetPowerBiConfig(): PowerBiEmbedConfig {
  const url = useMemo(() => "get_powerbi_config", []);
  const { loading, error, response } = useFetchGet(url);

  return {
    loading,
    error,
    embedConfig: response
  };
}
